import axios from 'axios';

import { env } from '@config/env';

/**
 * Cliente da base do DETRAN (xvia-xroad-mock-api). São as rotas `/detran/gestao/*`,
 * que ficam FORA do X-Road de propósito: o X-Road publica a consulta do
 * condutor, não a manutenção do cadastro interno da secretaria.
 */
export const detranClient = axios.create({
  baseURL: env.api.detranMockEndpoint,
});
